import Formatter from 'src/class/Formatter';
import Tables from 'src/class/Tables';
import i18n from "src/i18n";

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
          prop: 'date_save',
          label: i18n.t('common_words.date'),
          align: 'center',
          fixed: true,
          minWidth: 100,
        },
        {
          prop: 'farm',
          label: i18n.t('common_words.farm'),
          align: 'left',
          fixed: true,
          minWidth: 160,
        },
        {
          prop: 'lot',
          label: i18n.t('common_words.allotment'),
          align: 'center',
          fixed: true,
          minWidth: 100,
        },
        {
          prop: 'supervisor',
          label: i18n.t('grow.supervisor'),
          fixed: true,
          minWidth: 150,
        },
        {
          prop: 'worker',
          label: i18n.t('grow.operator_s'),
          minWidth: 220,
        },
        {
          prop: 'sample',
          label: i18n.t('grow.number_samples'),
          align: 'center',
          minWidth: 120,
        },
        {
          prop: 'avg_quality',
          label: i18n.t('grow.quality_percentage'),
          align: 'center',
          minWidth: 100,
          formatter: (row) => {
            return Formatter.formatNumber(row.avg_quality);
          },
        },
        {
          prop: 'number_hands',
          label: i18n.t('grow.number_hands'),
          align: 'center',
          minWidth: 120,
        },
        {
          prop: 'observations',
          label: i18n.t('common_words.observations'),
          minWidth: 250,
        },
        {
          prop: 'defects_qty',
          label: i18n.t('grow.number_defects_fingers'),
          align: 'center',
          minWidth: 120,
        },
    ];
    const Search = { ...Tables.Search };
    return { Table, Search };
};

export default configTable;